import React, { createContext, useContext, useRef } from 'react';

interface AddressValidationState {
    isValid: boolean;
    data: any;
}

interface AddressValidationContextType {
    validationRef: React.RefObject<AddressValidationState>;
}

const AddressValidationContext = createContext<AddressValidationContextType | undefined>(undefined);

export function AddressValidationStateProvider({ children }: { children: React.ReactNode }) {
    const validationRef = useRef<AddressValidationState>({ isValid: false, data: null });

    return (
        <AddressValidationContext.Provider value={{ validationRef }}>
            {children}
        </AddressValidationContext.Provider>
    );
}

export function useAddressValidationState() {
    const context = useContext(AddressValidationContext);
    if (!context) {
        throw new Error('useAddressValidationState must be used within AddressValidationStateProvider');
    }
    return context;
}
